import axios from "axios";

const userBaseURL = process.env.VUE_APP_USER_API_URL;
const lotteBaseURL = process.env.VUE_APP_LOTTE_API_URL;
export default {
  user: axios.create({
    baseURL: userBaseURL
  }),
  lotte: axios.create({
    baseURL: lotteBaseURL
  })
};
